import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const getDeleteLogsApi = async params => {
  const callResponse = await axios({
    url: endpoints.deletelogsBaseUrl,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then(response => response.data)
    .catch(err => err.response.data);

  return callResponse;
};


export const addDeleteLogsApi = async data => {
  const callResponse = await axios({
    url: endpoints.deletelogsBaseUrl,
    method: "POST",
    headers: getHeaders(),
    
    data,
  })
    .then(response => response.data)
    .catch(err => err.response.data);

  return callResponse;
};
